// Distinct from a load or print failure, so a caller can tell "the PDF window closed or never reported back" apart from "the browser refused to print".
export class PrintWindowTimeoutError extends Error {
  public constructor() {
    super('The PDF window closed or never finished loading.')
    this.name = 'PrintWindowTimeoutError'
  }
}
